import Vue from 'vue'
import AppCells from '@/components/AppCells'
import AppButton from '@/components/AppButton'
import AppFormGroup from '@/components/AppFormGroup'
import AppInput from '@/components/AppInput'
import AppFinNumber from '@/components/AppFinNumber'
import AppPhone from '@/components/AppPhone'
import AppCheckbox from '@/components/AppCheckbox'
import AppRadio from '@/components/AppRadio'
import AppSwitcher from '@/components/AppSwitcher'
import AppCropperWebCam from '@/components/AppCropperWebCam'
import AppUploader from '@/components/AppUploader'
import AppMultiUploader from '@/components/AppMultiUploader.vue'
import AppSpinner from '@/components/AppSpinner'
import AppPageLoader from '@/components/AppPageLoader'
import AppTextarea from '@/components/AppTextarea'
import AppFilters from '@/components/AppFilters'

Vue.component('AppCells', AppCells)
Vue.component('AppButton', AppButton)
Vue.component('AppFormGroup', AppFormGroup)
Vue.component('AppInput', AppInput)
Vue.component('AppFinNumber', AppFinNumber)
Vue.component('AppPhone', AppPhone)
Vue.component('AppCheckbox', AppCheckbox)
Vue.component('AppRadio', AppRadio)
Vue.component('AppSwitcher', AppSwitcher)
Vue.component('AppCropperWebCam', AppCropperWebCam)
Vue.component('AppUploader', AppUploader)
Vue.component('AppMultiUploader', AppMultiUploader)
Vue.component('AppSpinner', AppSpinner)
Vue.component('AppPageLoader', AppPageLoader)
Vue.component('AppTextarea', AppTextarea)
Vue.component('AppFilters', AppFilters)
